import { z } from 'zod';
import { numberParameter, withFmaSliceSettings, fmaSamplingSettings, fmaSliceParameters, fmaFullFieldSettings, fmaCircularParameter } from './shared.js';
import { CodevMtfFieldOptionsSchema, CODEV_MTF_FIELD_PARAMETERS } from './mtf_field.js';

export default {
  label: 'MTF Map', group: 'performance',
  description: 'Diffraction or geometrical MTF over a two-dimensional grid of field points, at one spatial frequency and orientation.',
  settingsSchema: withFmaSliceSettings({
    ...fmaSamplingSettings, ...CodevMtfFieldOptionsSchema.shape, ...fmaFullFieldSettings,
    // HIDD_FMAPAN5 describes the omitted 90/0 pair, but omitted FFD runs return
    // only 90 degrees, byte-identical to an explicit 90; the parser reads the
    // orientation from the native listing rather than assuming either.
    azimuth: z.number().nullable().default(null).describe('Target azimuth in degrees. Null (the default) omits it and lets CODE V choose: PromptingGuide p139 and HIDD_FMAPAN5 describe 90 and 0 degrees, but FFD returns only the 90-degree map (fma-mtf-map azimuth-default captures). Each request returns the native map at the orientations it lists.'),
  }),
  parameters: [
    ...CODEV_MTF_FIELD_PARAMETERS.map(parameter => parameter.key === 'azimuth'
      ? numberParameter('azimuth', 'Target azimuth', { unit: 'degrees', blank: 'CODE V default (90°)' }) : parameter),
    fmaCircularParameter, ...fmaSliceParameters,
  ],
  coverage: 'For focal (non-afocal) systems. Field points CODE V skips are left empty, without interpolation. With no orientation entered, the 90-degree map is shown. Square-wave response is not supported.',
} as const;
